<template>
  <div class="wrapper">
    <div
      v-if="itineraries.length"
      class="d-flex justify-content-between align-items-center data-page-top"
      data-aos="fade-up"
    >
      <h2 class="page-title">My Itineraries</h2>
      <RouterLink class="see-all" :to="{ name: 'itineraries' }">See all</RouterLink>
    </div>

    <div class="row">
      <div v-for="itinerary in itineraries" :key="itinerary.id" class="col-lg-6 col-xl-4 pad-bottom" data-aos="fade-up">
        <ProfileMyItinerariesItem :itinerary="itinerary" />
      </div>
    </div>
  </div>
</template>

<script>
import ProfileMyItinerariesItem from '@/components/partials/ProfileMyItinerariesItem.vue';
import itinerariesQuery from '@/graphql/itinerary/Itineraries.query.gql';

export default {
  name: 'ProfileMyItineraries',
  components: { ProfileMyItinerariesItem },
  apollo: {
    itineraries: {
      query: itinerariesQuery,
      variables() {
        return {
          limit: 3,
        };
      },
      update: (data) => data.itinerariesData.data,
    },
  },
  data() {
    return {
      itineraries: [],
    };
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.see-all {
  color: vars.$c-dark-gray;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 1.11px;
  text-decoration: underline;
  text-transform: uppercase;
}

.data-page-top {
  padding-bottom: 30px;
  margin-bottom: 0;
}

.pad-bottom {
  padding-bottom: 40px;
}

.page-title {
  margin-bottom: 0;
  color: vars.$c-dark-gray;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 2.86px;
  text-transform: uppercase;
}
</style>
